import React from 'react'
import PropTypes from 'prop-types'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

const outerStyle = {
  '--bs-tooltip-bg': 'transparent',
  '--bs-tooltip-color': '#212529',
  '--bs-tooltip-max-width': 'none',
  '--bs-tooltip-padding-x': '0',
  '--bs-tooltip-padding-y': '0',
  opacity: 1
}

const boxStyle = {
  whiteSpace: 'nowrap',
  background: '#f8f9fa',
  color: '#212529',
  border: '1px solid #dee2e6',
  borderRadius: '0.5rem',
  padding: '0.5rem 0.75rem',
  boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
  textAlign: 'left',
  fontSize: '0.9rem'
}

const LightTooltip = ({ content, placement = 'top', children }) => (
  <OverlayTrigger
    placement={placement}
    overlay={
      <Tooltip style={outerStyle}>
        <div style={boxStyle}>{content}</div>
      </Tooltip>
    }
  >
    {children}
  </OverlayTrigger>
)

LightTooltip.propTypes = {
  content: PropTypes.node.isRequired,
  placement: PropTypes.string,
  children: PropTypes.node.isRequired
}

export default LightTooltip
